nsr.factory('GrounfloorAccountService', ['$log', 'Admin', 'TransitionService', 'ErrorHandler', '$timeout', 'MessageService', function ($log, Admin, TransitionService, ErrorHandler) {

    var GrounfloorAccountService = { accounts: [] };

    GrounfloorAccountService.create = function (account) {
        return Admin.post('groundfloor-save', account)
            .success(function () {
            })
            .error(function (response) {
                    bootbox.dialog({
                        message: ErrorHandler.format(),
                        title: 'Error Saving Account',
                        buttons: {
                            main: {
                                label: "Ok",
                                className: "btn-primary",
                                callback: function () { }
                            }
                        }
                    });
                }
            );
    };

    return GrounfloorAccountService;
}]);

nsr.directive('ngFile', ['$parse', function ($parse) {
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            element.bind('change', function(){

                $parse(attrs.ngFile).assign(scope,element[0].files)
                scope.$apply();
            });
        }
    };
}]);